import { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';

import { Modal } from 'components/_basic/Modal';
import { ChangeDocAccessSelect } from 'components/ChangeDocAccessSelect/ChangeDocAccessSelect';
import { CopyLinkButton } from 'components/CopyLinkButton/CopyLinkButton';
import { ShareLinksForm } from 'components/ShareLinksForm/ShareLinksForm';

import { IManageShareOnePageProps } from '../type';

import styles from './ManageShareModal.module.scss';

interface IProps extends IManageShareOnePageProps {
  onModalClose: VoidFunction;
}

export const ManageShareModal: FC<IProps> = ({
  isRestricted,
  formLabel,
  formButtonText,
  isFormButtonDisabled,
  formError,
  dropdownValue,
  dropdownOptions,
  isLinkCopied,
  onDropdownChange,
  onCopyLinkClick,
  register,
  onModalClose,
  onFormSubmit,
  isRequestPending,
}) => (
  <Modal close={onModalClose}>
    <Grid container width="500px" gap="24px">
      <Grid item xs={12}>
        <Typography component="h3" variant="h3">
          Share Project
        </Typography>
      </Grid>
      {!isRestricted && (
        <Grid item xs={12}>
          <ShareLinksForm
            buttonText={formButtonText}
            label={formLabel}
            register={register}
            error={formError}
            isButtonDisabled={isFormButtonDisabled}
            onSubmit={onFormSubmit}
            isLoading={isRequestPending}
            endAdornmentText={t('canView')}
          />
        </Grid>
      )}
      <Grid item xs={12} className={styles.controlWrapper}>
        <ChangeDocAccessSelect
          value={dropdownValue}
          options={dropdownOptions}
          isRestricted={isRestricted}
          onChange={onDropdownChange}
        />
        <CopyLinkButton onClick={onCopyLinkClick} isLinkCopied={isLinkCopied} disabled={isRestricted} />
      </Grid>
    </Grid>
  </Modal>
);
